import apiClient from './apiClient';

export const workspaceApi = {
  getWorkspaces: async () => {
    const response = await apiClient.get('/workspaces');
    return response.data.map(ws => ({
      ...ws,
      id: ws.id.toString(), // Ensure ID is string for frontend consistency
      sources: ws.tables,
      chatsCount: ws.chat_count
    }));
  },

  getWorkspaceById: async (id) => {
    const response = await apiClient.get(`/workspaces/${id}`);
    return {
      ...response.data,
      id: response.data.id.toString(),
      sources: response.data.tables,
      chatsCount: response.data.chat_count
    };
  },

  createWorkspace: async (data) => {
    // data should contain { name, description, table_ids }
    const response = await apiClient.post('/workspaces', {
      name: data.name,
      description: data.description,
      table_ids: data.sources || [], // sources array from frontend wizard contains table IDs
      udf_ids: data.udf_ids || []
    });

    const ws = response.data;
    return {
      ...ws,
      id: ws.id.toString(),
      sources: ws.tables,
      chatsCount: ws.chat_count,
      lastAccessed: 'Just now'
    };
  },

  deleteWorkspace: async (id) => {
    const response = await apiClient.delete(`/workspaces/${id}`);
    return response.data;
  },

  updateWorkspace: async (id, data) => {
    // data should contain { name, description, sources, udf_ids }
    const payload = {};
    if (data.name !== undefined) payload.name = data.name;
    if (data.description !== undefined) payload.description = data.description;
    if (data.sources !== undefined) payload.table_ids = data.sources;
    if (data.udf_ids !== undefined) payload.udf_ids = data.udf_ids;

    const response = await apiClient.patch(`/workspaces/${id}`, payload);

    const ws = response.data;
    return {
      ...ws,
      id: ws.id.toString(),
      sources: ws.tables,
      chatsCount: ws.chat_count
    };
  },

  getWorkspaceArtefacts: async (workspaceId) => {
    const response = await apiClient.get(`/workspaces/${workspaceId}/artefacts`);
    return response.data;
  },

  getWorkspaceMapLayers: async (workspaceId) => {
    const response = await apiClient.get(`/workspaces/${workspaceId}/map-layers`);
    return response.data;
  },

  saveArtefact: async (workspaceId, data) => {
    const response = await apiClient.post(`/workspaces/${workspaceId}/artefacts`, data);
    return response.data;
  },

  updateArtefact: async (id, data) => {
    const response = await apiClient.patch(`/workspaces/artefacts/${id}`, data);
    return response.data;
  },

  deleteArtefact: async (id) => {
    const response = await apiClient.delete(`/workspaces/artefacts/${id}`);
    return response.data;
  }
};
